import { createSlice } from '@reduxjs/toolkit';
import { ninoxApiService } from '@store/services/ninoxApiService';
import { DataState } from '@models/ninox.model';

const initialState: DataState = {
  data: [],
  error: null,
  loading: false,
};

/**
 * Redux slice for managing data operations
 */
const dataSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // POST operations
    builder.addMatcher(
      ninoxApiService.endpoints.postData.matchFulfilled,
      (state, action) => {
        state.data = Array.isArray(action.payload) ? action.payload : [];
        state.loading = false;
      }
    );

    builder.addMatcher(
      ninoxApiService.endpoints.postData.matchPending,
      (state) => {
        state.loading = true;
        state.error = null; // 
      }
    );

    builder.addMatcher(
      ninoxApiService.endpoints.postData.matchRejected,
      (state, action) => {
        state.error = action.error?.message || 'Unknown error';
        state.loading = false;
      }
    );

    // PUT operations
    builder.addMatcher(
      ninoxApiService.endpoints.putData.matchFulfilled,
      (state, action) => {
        // Check if payload exists and has fields that's an array
        const payload = action.payload as Record<string, unknown>;
        const fields = payload && typeof payload === 'object' && payload.fields;
        state.data = Array.isArray(fields) ? fields : [];
        state.loading = false;
      }
    );

    builder.addMatcher(
      ninoxApiService.endpoints.putData.matchPending,
      (state) => {
        state.loading = true;
        state.error = null; // 
      }
    );

    builder.addMatcher(
      ninoxApiService.endpoints.putData.matchRejected,
      (state, action) => {
        state.error = action.error?.message || 'Unknown error';
        state.loading = false;
      }
    );

    // PATCH operations
    builder.addMatcher(
      ninoxApiService.endpoints.patchData.matchFulfilled,
      (state, action) => {
        // Cast to a type with id property for type safety
        const updatedFields = action.payload as Record<string, unknown> || {};
        
        // Only proceed with the map operation if updatedFields has an id property
        if ('id' in updatedFields) {
          state.data = state.data.map((item) =>
            item.id === updatedFields.id ? { ...item, ...updatedFields } : item
          );
        }
        
        state.loading = false;
      }
    );

    builder.addMatcher(
      ninoxApiService.endpoints.patchData.matchPending,
      (state) => {
        state.loading = true;
        state.error = null; 
      }
    );

    builder.addMatcher(
      ninoxApiService.endpoints.patchData.matchRejected,
      (state, action) => {
        state.error = action.error?.message || 'Unknown error';
        state.loading = false;
      }
    );
  },
});

export default dataSlice.reducer;